module.exports = __webpack_public_path__ + "public/img/aneka-kue.fab42e88.png";